import axios from 'axios';

import { ServerValidationError } from '@apple/utils/api/errors';

import type { Category, SaveCategoryRequest } from '../models/category';
import { categorySchema, deleteCategoryRequestSchema } from '../models/category';

/** @see Manzanita.Web.Features.Catalog.Categories.ProductCategoriesController */
export async function getById(id: number, signal: AbortSignal): Promise<Category> {
	const response = await axios.get(`/api/management/product-categories/${id}`, { signal });

	return categorySchema.parse(response.data);
}

/**
 * @see Manzanita.Web.Features.Catalog.Categories.ProductCategoriesController
 * Get a list of all product categories.
 **/
export async function getProductCategories(signal: AbortSignal): Promise<Category[]> {
	const response = await axios.get('/api/management/product-categories', { signal });

	return categorySchema.array().parse(response.data);
}

export async function saveProductCategory(category: SaveCategoryRequest): Promise<void> {
	const response = await axios.post('/api/management/product-categories', category, {
		validateStatus: status => status === 417 || status < 300,
	});

	if (response.status === 417) {
		throw new ServerValidationError<SaveCategoryRequest>(new Error('Duplicate Category'), {
			title: 'Duplicate Category',
			type: 'tag:apple.arvato.com:validation',
			detail: 'A category already exists with the provided category code',
			status: response.status,
			instance: response.config.url,
			fieldErrors: {
				categoryId: undefined,
				categoryCode: 'A category already exists with the provided category code',
				description: '',
				categoryImageUrl: '',
			},
		});
	}
}

export async function deleteProductCategory(id: number): Promise<void> {
	const request = deleteCategoryRequestSchema.parse({ idList: [id] });
	await axios.delete('/api/management/product-categories/', { params: request });
}
